import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../atoms';
import { ResponsiveImage } from '../../components';
import { useReferralRef, DASHBOARD_ZONE } from '../../referral';
import ReferImage from '../../images/account/Box.png';
import {
  StyledReferAFriendContainer,
  Content,
  ReferText,
  ReferHeading,
} from './styles';

export const ReferAFriend = ({ discountAmount }) => {
  const rafRef = useReferralRef(DASHBOARD_ZONE);
  return (
    <StyledReferAFriendContainer>
      <ResponsiveImage
        {...{ src: ReferImage, alt: 'ollie box', width: 92, height: 100 }}
      />
      <Content>
        <ReferHeading>Refer & Earn ${discountAmount}</ReferHeading>
        <ReferText>
          Refer your friends to Ollie! Give your friends a free box and we'll
          give you a ${discountAmount} account credit!
        </ReferText>
      </Content>
      <Button
        ref={rafRef}
        variant="sweetPotato"
        verticalPadding={4}
        horizontalPadding={22}
      >
        Refer a friend
      </Button>
    </StyledReferAFriendContainer>
  );
};

ReferAFriend.displayName = 'ReferAFriend';

ReferAFriend.propTypes = {
  discountAmount: PropTypes.number.isRequired,
};
